import React from "react";

export default function Spinner({ size = 24 }) {
  const stroke = 4;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 50 50"
      aria-hidden="true"
      style={{ animation: "ds-spin 1s linear infinite" }}
    >
      <circle
        cx="25"
        cy="25"
        r={20}
        fill="none"
        stroke="var(--brand)"
        strokeWidth={stroke}
        strokeDasharray={125}
        strokeDashoffset={100}
      />
      <style>{"@keyframes ds-spin{to{transform:rotate(360deg);}}"}</style>
    </svg>
  );
}
